"use client";

import { useEffect } from "react";

/**
 * Servis çalışanını kaydeder. Sayesinde bir kez açılan araçlar internet
 * olmadan da çalışır ve ikinci ziyaretler anında yüklenir.
 */
export function ServisCalisani() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    if (process.env.NODE_ENV !== "production") return;

    const kaydet = () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    };

    if (document.readyState === "complete") kaydet();
    else window.addEventListener("load", kaydet, { once: true });
  }, []);

  return null;
}
